



export function InstrucoesConvencionais() {

    return (

        <div className="text-lg">
            <div ><span className="font-bold">1.</span> Consulte a escala de trabalho (gráfico gant)</div>
            <hr className="mb-5" />
            <div><span className="font-bold">2.</span> Consulte dados da obra em APPRodrimaq&gt;Obras&gt;Data de entrega xxx&gt;Convencionais</div>
            <hr className="mb-5" />
            <div><span className="font-bold">3.</span> Situe o material identificado com a obra e o respetivo desenho na APP/Servidor;</div>
            <hr className="mb-5" />
            <div className="mb-2"><span className="font-bold">4.</span> Proceda à intervenção no bloco:</div>

            <div className="ml-10">
                <div className="mb-2"><span className="font-bold">a.</span> Torneamento de peça;</div>
                <div className="mb-2"><span className="font-bold">b.</span> Fresagem para retirada de mínimos para aperto;</div>
            </div>
            <hr className="mb-5" />
            <div ><span className="font-bold">5.</span> De seguida, depositar:</div>
            <div className="ml-10">
                <div className="mb-2"><span className="font-bold">a.</span> Peças torneadas</div>
                <div className="ml-10">
                    <div className="mb-2"><span className="font-bold">i.</span> Em “Material para Acabamento” as peças torneadas para acabamentos;</div>
                    <div className="mb-2"><span className="font-bold">ii.</span> Em “Peças para Controlo” as peças torneadas prontas para análise;</div>

                </div>
                <div className="mb-2"><span className="font-bold">b.</span> Brutos Mínimos – na estante central com a respetiva identificação inicial.</div>
            </div>
            <hr className="mb-5" />
            <div className="mt-10"><span className="font-bold">Notas:</span> Blocos NOK devem ser colocados na caixa vermelha existente no setor. Tente, sempre que possível,
                manter o setor limpo e organizado.</div>

        </div>
    )
}